<div class="drawer-layout">

  <div class="drawer-content">
    <button mat-button
            class="drawer-action-button"
            [matMenuTriggerFor]="timeFilterMenu"
    >
      <mat-icon>timer</mat-icon> <span class="button-label">Last {{ sinceHours }} hours</span> <span><mat-icon class="button-label dropdown-icon">arrow_drop_down</mat-icon></span>
    </button>
    <mat-menu #timeFilterMenu="matMenu">
      @for (item of sinceHoursItems; track item) {
        <button
          mat-menu-item
          (click)="hoursFilterChanged(item)"
          class="drawer-action-menu-item"
        >
          Last {{ item }} hours
        </button>
      }
    </mat-menu>
  </div>

  @if (items && items.length > 0) {
    <div cdkDropList
         class="drawer-content"
         [cdkDropListData]="items"
         (cdkDropListDropped)="drop($event)"
    >
      @if (existingPinnedItems()) {
        <div class="pinned-items">
          @for (item of items; track $index) {
            @if (item.actionIcon.endsWith('_true')) {
              <app-card-menu-item
                class="insight-card"
                cdkDrag
                [cdkDragData]="item"
                [item]="item"
              ></app-card-menu-item>
            }
          }
          <div class="divider"></div>
        </div>
      }

      @for (item of items; track $index) {
        @if (item.actionIcon.endsWith('_false')) {
          <app-card-menu-item
            class="insight-card"
            cdkDrag
            [cdkDragData]="item"
            [item]="item"
          ></app-card-menu-item>
        }
      }
    </div>
  }
</div>
